import { ComponentHeader, StyledCreate } from "@components";
import { GenerateCouponForm } from "@modules";
import { useTranslation } from "react-i18next";

export const PageGenerateCoupon = () => {
  const { t } = useTranslation();

  return (
    <>
      <ComponentHeader title={t("page.generate_coupon")} />
      <StyledCreate>
        <GenerateCouponForm />
      </StyledCreate>
    </>
  );
};
